module.exports = __webpack_public_path__ + "static/blue_block_mask-6530a6b6e758c1839b4f11ab3a769a2b.png";